export default "__VITE_ASSET__BwnpbaM8__"